import { render } from "./SearchQuestionView.vue?vue&type=template&id=1115e4f5"
import script from "./SearchQuestionView.vue?vue&type=script&lang=js"
export * from "./SearchQuestionView.vue?vue&type=script&lang=js"

import "./SearchQuestionView.vue?vue&type=style&index=0&id=1115e4f5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__